import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-orginization-structure',
  templateUrl: './orginization-structure.component.html',
  styleUrls: ['./orginization-structure.component.scss']
})
export class OrginizationStructureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
